module.exports = __webpack_public_path__ + "img/jumbo.83467fc6.jpg";